import React from "react";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import WhatWeDo from "../../whatWeDo/WhatWeDo.component";
import DAF2TreasuryFiltersAndReports from "./DAF2TreasuryFiltersAndReports.component";
import { HedgeRatioProvider } from "../../../context/HedgeRatioContext";
import useStyles from "./DAF2Treasury.styles";
import { TreasuryKRISummaryProvider } from "../../../context/TreasuryKRISummaryContext";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.primary,
}));

const DAF2Treasury = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.page}>
      <Grid container item spacing={2}>
        <HedgeRatioProvider>
          <TreasuryKRISummaryProvider>
            <DAF2TreasuryFiltersAndReports />
          </TreasuryKRISummaryProvider>
        </HedgeRatioProvider>
        <Grid size={{ xs: 12, md: 12 }} sx={{ display: "none" }}>
          <Item>
            <WhatWeDo />
          </Item>
        </Grid>
      </Grid>
    </div>
  );
};

export default DAF2Treasury;
